<template>
  <div>
    <div v-if="fullscreen" class="sc-spinner-backdrop"></div>
    <div
      class="sc-spinner"
      :class="{ 'sc-fullscreen-spinner': fullscreen }">
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScSpinner',
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.sc-spinner {
  content: " ";
  display: block;
  width: $sc-spinner-size;
  height: $sc-spinner-size;
  margin: 1px;
  border-radius: 50%;
  border: 1px solid $sc-spinner-color;
  border-color: $sc-spinner-color transparent $sc-spinner-color transparent;
  animation: lds-dual-ring 0.5s linear infinite;
}
.sc-spinner-backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $sc-confirmdialog-backdrop-color;
  z-index: 9999
}
.sc-fullscreen-spinner {
  width: $sc-spinner-fullscreen-size;
  height: $sc-spinner-fullscreen-size;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
